import { render, staticRenderFns } from "./favorite-franchises.vue?vue&type=template&id=4cc8b3eb&scoped=true&"
import script from "./favorite-franchises.vue?vue&type=script&lang=js&"
export * from "./favorite-franchises.vue?vue&type=script&lang=js&"
import style0 from "./favorite-franchises.vue?vue&type=style&index=0&id=4cc8b3eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc8b3eb",
  null
  
)

export default component.exports